import { useMemo } from 'react'
import { useSolanaWallets } from '@towns/privy'
import { useMyAbstractAccountAddress } from 'hooks/useAbstractAccountAddress'

export const useTradingWalletAddresses = () => {
    const { wallets: solanaWallets } = useSolanaWallets()
    const solanaWalletAddress = useMemo(
        () => solanaWallets.find((w) => w.walletClientType === 'privy')?.address,
        [solanaWallets],
    )

    const { data: evmWalletAddress } = useMyAbstractAccountAddress()

    return { evmWalletAddress, solanaWalletAddress }
}
